var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.chartsLoaded && _vm.modulo != 'financeiro' ? _c('b-card', {
    staticClass: "chartContainer"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.barChartOptions,
      "series": _vm.reaisSeries
    }
  })], 1)], 1)], 1) : _vm.chartsLoaded && _vm.modulo == 'financeiro' ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-custom card-stretch",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-success font-weight-bolder font-size-h1 text-dark-75"
  }, [_c('ArrowUp', {
    attrs: {
      "size": 16,
      "fillColor": "#1BC5BD"
    }
  }), _vm._v(" R$ " + _vm._s(_vm.totalReceitas) + " ")], 1), _c('span', {
    staticClass: "font-weight-bold font-size-lg"
  }, [_vm._v("Receitas")])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-custom card-stretch",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-success font-weight-bolder font-size-h1 text-dark-75"
  }, [_c('ArrowDown', {
    attrs: {
      "size": 16,
      "fillColor": "#F64E60"
    }
  }), _vm._v(" R$ " + _vm._s(_vm.totalDespesas) + " ")], 1), _c('span', {
    staticClass: "font-weight-bold font-size-lg"
  }, [_vm._v("Despesas")])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-custom card-stretch",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', {
    staticClass: "svg-icon svg-icon-2x svg-icon-success ard-title font-weight-bolder font-size-h1 text-dark-75"
  }, [_c('Bank', {
    attrs: {
      "size": 16,
      "fillColor": _vm.colorCaixa
    }
  }), _vm._v(" R$ " + _vm._s(_vm.saldoCaixa) + " ")], 1), _c('span', {
    staticClass: "font-weight-bold font-size-lg"
  }, [_vm._v("Saldo")])])])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };